import { render } from "./NInput.vue?vue&type=template&id=317afaf4&ts=true"
import script from "./NInput.vue?vue&type=script&lang=ts"
export * from "./NInput.vue?vue&type=script&lang=ts"

import "./NInput.vue?vue&type=style&index=0&id=317afaf4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__